import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReduxStatus from '../constants/ReduxStatus';

const useStyles = makeStyles({
  contentContainer: {
    width: 300,
    minHeight: 100,
    maxWidth: '80vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontSize: 14,
    fontFamily: 'Quicksand, sans-serif',
  },
});

const ReduxStatusVisualizedComponent = ({
  reduxStatus,
  error,
}) => {
  const classes = useStyles();
  const [isShowLoading, setIsShowLoading] = useState(false);
  const [isShowSuccess, setIsShowSuccess] = useState(false);
  const [isShowError, setIsShowError] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  useEffect(() => {
    switch (reduxStatus) {
      case ReduxStatus.STATUS_LOADING:
        setIsShowLoading(true);
        setIsShowSuccess(false);
        setIsShowError(false);
        setIsShowModal(true);
        break;
      case ReduxStatus.STATUS_NORMAL:
        setIsShowLoading(false);
        setIsShowSuccess(true);
        setIsShowError(false);
        break;
      case ReduxStatus.STATUS_ERROR:
        setIsShowLoading(false);
        setIsShowSuccess(false);
        setIsShowError(true);
        break;
      default:
        setIsShowLoading(false);
        setIsShowSuccess(true);
        setIsShowError(false);
        setIsShowModal(false);
    }
  }, [reduxStatus]);

  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      onClose={() => setIsShowModal(false)}
      open={isShowModal}
    >
      <div className={classes.contentContainer}>
        { isShowLoading && (
          <div>
            <CircularProgress />
          </div>
        )}
        { isShowError && (
          <div className={classes.text}>
            {error}
            Oops! Something happened, try later
          </div>
        )}
        { isShowSuccess && (
          <div className={classes.text}>
            Thanks for sending us a note!
          </div>
        )}
      </div>
    </Dialog>
  );
};

ReduxStatusVisualizedComponent.propTypes = {
  reduxStatus: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

ReduxStatusVisualizedComponent.defaultProps = {
  reduxStatus: '',
  error: null,
};

export default ReduxStatusVisualizedComponent;
